import { render, staticRenderFns } from "./HomeCareOrderNumber.vue?vue&type=template&id=8edc6bb0&scoped=true&"
import script from "./HomeCareOrderNumber.vue?vue&type=script&lang=js&"
export * from "./HomeCareOrderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc6bb0",
  null
  
)

export default component.exports